import React from 'react';

import {
  type AccountType,
  type BaseSvgProps,
  colorToHexCode,
} from '../../utils';

export const Entry = ({
  width = 12,
  'data-testid': testId,
  types,
  disabled = false,
}: BaseSvgProps & {
  types: AccountType[];
  disabled?: boolean;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    className="shrink-0"
    viewBox="0 0 12 12"
    data-testid={testId}
    data-asset-active={types.includes('asset')}
    data-liability-active={types.includes('liability')}
    data-income-active={types.includes('income')}
    data-expense-active={types.includes('expense')}
  >
    <path
      d="M6.07397 6H12.074C12.074 9.31371 9.38768 12 6.07397 12V6Z"
      fill="rgb(var(--colour-inactive-tl))"
    />
    <path
      d="M6.07397 0C9.38768 0 12.074 2.68629 12.074 6H6.07397V0Z"
      fill="rgb(var(--colour-inactive-tr))"
    />
    <path
      d="M0.0739746 6H6.07397V12C2.76027 12 0.0739746 9.31371 0.0739746 6Z"
      fill="rgb(var(--colour-inactive-bl))"
    />
    <path
      d="M0.0739746 6C0.0739746 2.68629 2.76027 0 6.07397 0V6H0.0739746Z"
      fill="rgb(var(--colour-inactive-br))"
    />
    <path
      d="M6.07397 6H12.074C12.074 9.31371 9.38768 12 6.07397 12V6Z"
      fill={
        types.includes('expense') && !disabled
          ? colorToHexCode['expense-yellow']
          : 'transparent'
      }
    />
    <path
      d="M6.07397 0C9.38768 0 12.074 2.68629 12.074 6H6.07397V0Z"
      fill={
        types.includes('income') && !disabled
          ? colorToHexCode['income-blue']
          : 'transparent'
      }
    />
    <path
      d="M0.0739746 6H6.07397V12C2.76027 12 0.0739746 9.31371 0.0739746 6Z"
      fill={
        types.includes('liability') && !disabled
          ? colorToHexCode['liability-red']
          : 'transparent'
      }
    />
    <path
      d="M0.0739746 6C0.0739746 2.68629 2.76027 0 6.07397 0V6H0.0739746Z"
      fill={
        types.includes('asset') && !disabled
          ? colorToHexCode['asset-green']
          : 'transparent'
      }
    />
  </svg>
);
